import accountH24 from './h24/account.svg?sprite';
import accountFfh from './ffh/accountFfh.svg?sprite';
import arrowLeft from './arrow-left.svg?sprite';
import arrowRight from './arrow-right.svg?sprite';
import arrowLightDown from './arrow-light-down.svg?sprite';
import arrowStrongRight from './arrow-strong-right.svg?sprite';
import bin from './bin.svg?sprite';
import burger from './burger.svg?sprite';
import cameraOutline from './camera-outline.svg?sprite';
import cartH24 from './h24/cart.svg?sprite';
import cartFfh from './ffh/cartFfh.svg?sprite';
import checkboxActive from './checkbox/checkbox-active.svg?sprite';
import checkboxCheckedInactive from './checkbox/checkbox-checked-inactive.svg?sprite';
import checkboxDefault from './checkbox/checkbox-default.svg?sprite';
import checkboxInactive from './checkbox/checkbox-inactive.svg?sprite';
import clear from './clear.svg?sprite';
import close from './close.svg?sprite';
import closeStrong from './close-strong.svg?sprite';
import closeStrongSmall from './close-strong-small.svg?sprite';
import copy from './copy.svg?sprite';
import defaultProductImage from './default-product-image.svg?sprite';
import discount from './discount.svg?sprite';
import edit from './edit.svg?sprite';
import error from './error.svg?sprite';
import facebook from './facebook.svg?sprite';
import filteringSorting from './filtering-sorting.svg?sprite';
import history from './history.svg?sprite';
import info from './info.svg?sprite';
import invisible from './invisible.svg?sprite';
import instagram from './instagram.svg?sprite';
import landscapeOutline from './landscape-outline.svg?sprite';
import lightCheck from './light-check.svg?sprite';
import list from './list.svg?sprite';
import materials from './materials.svg?sprite';
import paybackShort from './payback-short.svg?sprite';
import plusStrong from './plus-strong.svg?sprite';
import play from './play.svg?sprite';
import printer from './printer.svg?sprite';
import radioDefault from './radio-default.svg?sprite';
import radioSelected from './radio-selected.svg?sprite';
import returnCircle from './return.svg?sprite';
import search from './search.svg?sprite';
import security from './security.svg?sprite';
import spinner from './spinner.svg?sprite';
import sustain from './sustain.svg?sprite';
import trustPilotStar from './trust-pilot-star.svg?sprite';
import subscribe from './subscribe.svg?sprite';
import success from './success.svg?sprite';
import truck from './truck.svg?sprite';
import videocall from './videocall.svg?sprite';
import visible from './visible.svg?sprite';
import warning from './warning.svg?sprite';
import wishlist from './wishlist.svg?sprite';
export default {
    accountH24: accountH24,
    accountFfh: accountFfh,
    arrowLeft: arrowLeft,
    arrowRight: arrowRight,
    arrowLightDown: arrowLightDown,
    arrowStrongRight: arrowStrongRight,
    bin: bin,
    burger: burger,
    cameraOutline: cameraOutline,
    cartH24: cartH24,
    cartFfh: cartFfh,
    checkboxActive: checkboxActive,
    checkboxCheckedInactive: checkboxCheckedInactive,
    checkboxDefault: checkboxDefault,
    checkboxInactive: checkboxInactive,
    clear: clear,
    close: close,
    closeStrongSmall: closeStrongSmall,
    closeStrong: closeStrong,
    copy: copy,
    defaultProductImage: defaultProductImage,
    discount: discount,
    edit: edit,
    error: error,
    facebook: facebook,
    filteringSorting: filteringSorting,
    history: history,
    info: info,
    invisible: invisible,
    instagram: instagram,
    landscapeOutline: landscapeOutline,
    lightCheck: lightCheck,
    list: list,
    materials: materials,
    paybackShort: paybackShort,
    play: play,
    plusStrong: plusStrong,
    printer: printer,
    radioDefault: radioDefault,
    radioSelected: radioSelected,
    returnCircle: returnCircle,
    search: search,
    security: security,
    spinner: spinner,
    sustain: sustain,
    trustPilotStar: trustPilotStar,
    subscribe: subscribe,
    success: success,
    truck: truck,
    videocall: videocall,
    visible: visible,
    warning: warning,
    wishlist: wishlist,
};
